// events service
// provides a global event bus for app-wide events (error handling, etc.)

import Vue from 'vue'

// global event bus
var bus = new Vue()

export default {
  bus: bus,
  emit: function () {
    this.bus.$emit(...arguments)
  }
}



// WEBPACK FOOTER //
// ./src/services/events/index.js